import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";

import IconAdd from "@material-ui/icons/Add";

import { GridColumns } from "./producerphgridsetup";
import ProducerPHEditForm from "./producerpheditform";

import Grid from "../../lib/components/grid";
import Confirmation from "../../lib/components/confirmation";
import { producerph, ProducerPHType, getProducerPHFull, GetProducerPHFullType } from "../../lib/api/producerph";
import { producerphattachment } from "../../lib/api/producerphattachment";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
      width: "700px",
      height: "100%",
      position: "relative",
      paddingTop: 0,
      marginTop: "-3px",
    },
    inline: {
      display: "inline",
      position: "absolute",
      marginTop: "7px",
      marginLeft: "7px",
    },
    grid: {
      // marginTop: "-10px",
      width: "100%",
      float: "left",
    },
  });

type ProducerPHProps = {
  producerid: any;
  handleRefresh: () => void;
} & WithStyles<typeof styles>;

export class ProducerPHUnstyled extends React.Component<ProducerPHProps, any> {
  state = {
    classes: undefined,
    data: [],
    confirmRemoveID: undefined,
    confirmEditID: undefined,
    producerid: undefined,
    loading: true,
  };

  constructor(props) {
    super(props);
    this.state.classes = props.classes;

    if (props.producerid) {
      this.state.producerid = props.producerid;
    }
  }

  componentDidMount() {
    this.loadData();
  }

  componentWillReceiveProps(props) {
    this.setState({ producerid: props.producerid }, () => {
      this.loadData();
    });
  }

  loadData = () => {
    getProducerPHFull(this.state.producerid).then((data) => {
      const dataSorted = data.sort((a, b) => {
        if (a.code > b.code) return 1;
        if (a.code < b.code) return -1;
        return 1;
      });

      this.setState({ data: dataSorted, loading: false });
    });
  };

  handleCreate = () => {
    this.setState({ confirmEditID: "0" });
  };

  handleEdit = (id) => {
    this.setState({ confirmEditID: id });
  };

  handleEditClose = () => {
    this.setState({ confirmEditID: undefined });
  };

  handleEditConfirm = async (item, files) => {
    let id = item["id"];
    const orgid = item["id"];
    const producerphV: ProducerPHType = {
      producer_id: this.state.producerid,
      validfrom: item.validfrom,
      validto: item.validto,
      producerphtype_id: item.producerphtype_id && item.producerphtype_id != 0 ? item.producerphtype_id : null,
    };

    if (id == "0") {
      await producerph.create({ data: { ...producerphV } }).then((result) => (id = result[0]));
    } else {
      await producerph.update(id, { data: { ...producerphV } });
    }

    this.loadData();

    if (files && files.length > 0) {
      files.map((file) => {
        if (!file.id) {
          producerphattachment.create({ data: { ...file, producerph_id: id } });
        }
      });
    }

    if (orgid == 0) {
      this.setState({ confirmEditID: id });
      return;
    }
    await this.handleEditClose();
    this.props.handleRefresh();
  };

  handleRemove = async (id) => {
    this.setState({ confirmRemoveID: id });
  };

  handleRemoveClose = () => {
    this.setState({ confirmRemoveID: undefined });
  };

  handleRemoveConfirm = async () => {
    await producerph.remove(this.state.confirmRemoveID).then(() => {
      this.handleRemoveClose();
      this.loadData();
    });
  };

  GridColumnsOverride = (column, row) => {
    return GridColumns(column, row, this.handleRemove, this.handleEdit);
  };

  render() {
    const { classes } = this.state;

    return (
      <div className={classes.root}>
        {this.state.producerid && this.state.producerid == "0" ? (
          <div>New Producer. Cannot add Packhouse</div>
        ) : (
          <div>
            <div className={classes.inline}>
              <Tooltip title="Create new PH Treatment">
                <div className={classes.inline}>
                  <Button variant="contained" color="primary" onClick={this.handleCreate} style={{ marginBottom: "10px" }}>
                    <IconAdd />
                  </Button>
                </div>
              </Tooltip>
            </div>
            <div style={{ width: "600px" }}>
              <Grid loading={this.state.loading} data={this.state.data} GridColumns={this.GridColumnsOverride} clearFilters={"producerphgridsetup"} />
            </div>
            {this.state.confirmRemoveID && (
              <Confirmation
                isOpen={this.state.confirmRemoveID ? true : false}
                handleClose={this.handleRemoveClose}
                handleConfirm={this.handleRemoveConfirm}
                title="Remove selected PH Treatment?"
                body="Are you sure you want to REMOVE the selected PH Treatment Record?"
              ></Confirmation>
            )}
            {this.state.confirmEditID && (
              <Confirmation
                isOpen={this.state.confirmEditID ? true : false}
                handleClose={this.handleEditClose}
                handleConfirm={() => {}}
                title={this.state.confirmEditID == "0" ? "Creating PH Treatment" : "Editing PH Treatment"}
                body={undefined}
              >
                <ProducerPHEditForm onSubmit={this.handleEditConfirm} onClose={this.handleEditClose} id={this.state.confirmEditID} />
              </Confirmation>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(ProducerPHUnstyled);
